import { useMutation, useQueryClient } from 'react-query';
import {
  errorMock,
  GetCustomerResponse,
  IFindCallerResponse,
  IShoppingCartResponse,
} from '@vfit/consumer/data-access';
import { API, getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { nextClient, LoggerInstance, INextError, CustomOptions } from '@vfit/shared/data-access';

export interface ICheckPrepaidSimLimitation {
  orderId: string;
  orderActionType: string;
  offeringDetails?: any[];
  productOfferingProductSpecID?: string;
}

export interface ICheckPrepaidSimLimitationResponse {
  validationStatus: string;
  errorDetails: {
    errorCode: string;
    errorMessage: string;
  };
}

/**
 * Methods to invoke the POST checkPrepaidSIMLimitation service
 * @param payload
 * @param customOptions
 * @param customerId
 * @returns
 */
const checkPrepaidSIMLimitation = (
  payload: ICheckPrepaidSimLimitation,
  customerId: string,
  customOptions?: CustomOptions,
): Promise<ICheckPrepaidSimLimitationResponse> =>
  nextClient.post(`${API.CHECK_SIM_LIMIT}/${customerId}`, payload, {
    searchParams: {
      salesChannel: 'selfService',
    },
    ...(customOptions?.headers && { headers: customOptions.headers }),
    ...(customOptions?.silentLoginHeaders && {
      silentLoginHeaders: customOptions.silentLoginHeaders,
    }),
  });

/**
 * Custom mutation hook for run validateDuplicateOrderService.
 * @returns
 */
export const useCheckPrepaidSIMLimitation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'checkPrepaidSIMLimitation',
    () => {
      // Get shoppingCart from local storage
      const shoppingCartSaved = localStorage.getItem('shoppingCart');
      const shoppingCart: IShoppingCartResponse =
        !!shoppingCartSaved && JSON.parse(shoppingCartSaved as string);
      const orderId = shoppingCart?.order?.id;
      const findCaller: IFindCallerResponse = getFromLocalStorageByKey('findCaller');
      const customerData: GetCustomerResponse[] = getFromLocalStorageByKey('customerData');
      const customerId = findCaller?.customerRef?.id || customerData?.[0]?.id;

      const payload: ICheckPrepaidSimLimitation = {
        orderId: orderId,
        offeringDetails: [],
        orderActionType: 'PR',
      };
      return checkPrepaidSIMLimitation(payload, customerId);
    },
    {
      onSuccess: (data) => {
        if (data) {
          localStorage.setItem('checkPrepaidSIMLimitation', JSON.stringify(data));
          queryClient.setQueryData('checkPrepaidSIMLimitation', data);
        }
      },
      onError: (error) => {
        LoggerInstance.error(`ERROR - checkPrepaidSIMLimitation: `, error);
        queryClient.setQueryData(
          'checkPrepaidSIMLimitation',
          errorMock(`checkPrepaidSIMLimitation`, error as INextError),
        );
        localStorage.setItem(
          `checkPrepaidSIMLimitation`,
          JSON.stringify(errorMock(`checkPrepaidSIMLimitation`, error as INextError)),
        );
      },
    },
  );
};

